import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';

const ClientAccountList = lazy(
  () => import('@components/ClientAccount/ClientAccountList')
);

/** 마스터 계정 > 회사 계정 관리 */
const ClientAccount = () => {
  return (
    <>
      <ApiErrorBoundary>
        <Suspense>
          <ClientAccountList />
        </Suspense>
      </ApiErrorBoundary>
    </>
  );
};

export default ClientAccount;
